<template>
  <div>
    <b-collapse animation="slide" :open="false" aria-id="contentIdForA11y3">
      <template #trigger="props">
        <div card-content>
          <div
            class="header is-flex has-gap-3 is-align-items-center"
            role="button"
            aria-controls="contentIdForA11y3"
            :aria-expanded="props.open"
          >
            <div>
              <h4 class="card-header-title is-pulled-left m-0">
                {{ $t("mp:deal.transaction.tab.transaction") }}
              </h4>
            </div>
            <div>
              <p class="is-size-8 is-uppercase mb-1">
                {{ $t("mp:deal.transaction.tab.due") }}
              </p>
              <span class="has-text-weight-medium">
                {{ localizedFormatter(country.languageIso).date(transaction.dueDate) }}
              </span>
            </div>
            <div>
              <p class="is-size-7 is-uppercase mb-1">
                {{ $t("mp:deal.transaction.tab.amount") }}
              </p>
              <span class="has-text-weight-medium">
                {{ localizedFormatter(country.languageIso).money(deal.currencyIso, transaction.sum) }}
              </span>
            </div>
            <div>
              <p class="is-size-7 is-uppercase mb-1">
                {{ $t("mp:deal.transaction.tab.status") }}
              </p>
              <span
                class="has-text-weight-medium"
                :class="BNPL_TRANSACTION_STATUS.COLOR[transaction.status]"
                >{{
                  $t(BNPL_TRANSACTION_STATUS.TOKEN[transaction.status])
                }}</span
              >
            </div>
            <div>
              <!-- v-if="props.open" -->
              <p class="is-size-7 is-uppercase mb-1">
                {{ $t("mp:deal.transaction.tab.number.of.late.days") }}
              </p>
              <span class="has-text-weight-medium">{{ lateDays }}</span>
            </div>
            <div>
              <!-- v-if="props.open" -->
              <p class="is-size-7 is-uppercase mb-1">
                {{ $t("mp:deal.transaction.tab.flag") }}
              </p>
              <span
                class="has-text-weight-medium"
                :class="BNPL_DEAL_TRANSACTION_FLAG.COLOR[flag]"
              >
                {{ $t(BNPL_DEAL_TRANSACTION_FLAG.TOKEN[flag]) }}
              </span>
            </div>
            <a class="card-header-icon ml-auto">
              <b-icon :icon="props.open ? 'chevron-up' : 'chevron-down'">
              </b-icon>
            </a>
          </div>
        </div>
      </template>
      <div class="is-flex is-flex-direction-column pb-3 has-gap-3">
        <div
          v-for="attempt in transactionAttempts"
          :key="attempt.field"
          class="is-flex body-rows is-align-items-center mt-5 has-gap-2"
        >
          <div v-if="!attempt.hide">
            <p class="is-size-7 is-uppercase mb-1 px-1">
              {{ $t("bnpl:deal.transaction.tab.attempted.payment") }}
            </p>
            <span v-if="!attempt.hide">
              {{ localizedFormatter(country.languageIso).dateTime (attempt.timestamp) }}
            </span>
          </div>
          <div v-if="!attempt.hide">
            <p class="is-size-7 is-uppercase mb-1 px-1">
              {{ $t("mp:deal.transaction.tab.attempt.result") }}
            </p>
            <span v-if="!attempt.hide" :class="getColor(attempt.result)"
              >{{
                $t(BNPL_DEAL_TRANSACTION_ATTEMPT_STATUS.TOKEN[attempt.result])
              }}
            </span>
          </div>
          <div v-if="!attempt.hide">
            <p class="is-size-7 is-uppercase mb-1 px-1">
              {{ $t("mp:deal.transaction.tab.service.fee") }}
            </p>
            <span class="has-text-weight-medium">
              {{ localizedFormatter(country.languageIso).money(deal.currencyIso, transaction.fee) }}
            </span>
          </div>
          <div v-if="!attempt.hide">
            <p class="is-size-7 is-uppercase mb-1">
              {{ $t("mp:deal.transaction.tab.late.fee") }}
            </p>
            <span class="has-text-weight-medium">
              {{ localizedFormatter(country.languageIso).money(deal.currencyIso, transaction.latenessFee) }}
            </span>
          </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { formatDate, formatDateTime, formatMoney, localizedFormatter } from "@/utils/util";
import {
  BNPL_DEAL_TRANSACTION_ATTEMPT_STATUS,
  BNPL_DEAL_TRANSACTION_FLAG,
  BNPL_TRANSACTION_STATUS,
} from "@/utils/const";
import { mapGetters } from "vuex/dist/vuex.common.js";
export default {
  name: "BnplTransactionsRow",
  props: {
    transaction: {
      type: Object,
      require: true,
    },
    deal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loaded: false,
      BNPL_TRANSACTION_STATUS,
      BNPL_DEAL_TRANSACTION_ATTEMPT_STATUS,
      BNPL_DEAL_TRANSACTION_FLAG,
      transactionAttempts: [],
    };
  },
  computed: {
    ...mapGetters({
      country: "i18n/country",
    }),
    lateDays() {
      if (this.transaction.status !== BNPL_TRANSACTION_STATUS.ENUM.DELAYED)
        return "-";

      const now = new Date();
      const due = new Date(this.transaction.dueDate);
      const diffTime = now - due;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays >= 0 ? diffDays : "-";
    },
    flag() {
      if (this.lateDays === "-" || this.lateDays === 0)
        return BNPL_DEAL_TRANSACTION_FLAG.ENUM.NONE;
      if (!this.deal?.latenessThreshold)
        return BNPL_DEAL_TRANSACTION_FLAG.ENUM.DELAYED;
      if (this.deal.latenessThreshold >= this.lateDays)
        return BNPL_DEAL_TRANSACTION_FLAG.ENUM.DELAYED;
      return BNPL_DEAL_TRANSACTION_FLAG.ENUM.EXPIRED;
    },
  },
  methods: {
    formatDate,
    formatMoney,
    formatDateTime,
    localizedFormatter,
    getDate(date, part) {
      // example: 2021.06.15. 13:44 where part=1 is the time
      const d = formatDateTime(date);
      return d.split(" ")[part];
    },
    getColor(attemptResult) {
      return attemptResult === BNPL_DEAL_TRANSACTION_ATTEMPT_STATUS.ENUM.SUCCESS
        ? "attempt-result-green"
        : "attempt-result-red";
    },
  },
  async created() {
    this.transactionAttempts = this.transaction.attempts;
    this.transactionAttempts.forEach(
      (it) => (it.token = "bnpl:deal.transaction.tab.attempted.payment")
    );
    this.transactionAttempts = this.transactionAttempts.sort(
      (a, b) => b.timestamp - a.timestamp
    );
    this.transactionAttempts.push({
      timestamp: this.transaction.dueDate,
      token: "bnpl:deal.transaction.tab.due.payment",
      hide: true,
    });
    this.loaded = true;
  },
};
</script>

<style lang="scss" scoped>
.body-rows {
  padding-left: 30px;
}
.attempt-result-red {
  color: red;
  padding-left: 5px;
}
.attempt-result-green {
  color: green;
  padding-left: 5px;
}
</style>
